
// src/routes/PrivateRoute.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext);

  // ✅ Si connecté, affiche les enfants. Sinon redirige vers /login proprement.
  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
